import { Component, Input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import { CardComponent } from '@legacy/common-ui-partials';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';

@Component({
  selector: 'wl-card-content-block',
  templateUrl: './card-content-block.component.html',
  standalone: true,
  imports: [CardComponent, JssModule],
})
export class CardContentBlockComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;
}
